import React, { useMemo, useEffect, useRef, memo } from "react";
import { isEmpty } from "../../../helpers/Functions";
import { DIR_USER_PROFILE } from "../../../models/Constants";
import { Image } from "react-bootstrap";

const Avatar = memo(({ setUpdate = () => {}, transparentBg = false, ...props }) => {
	const hasMounted = useRef(false);

	const avatar = useMemo(() => {
		const first = props?.userdetail?.firstname || "";
		const last = props?.userdetail?.lastname || "";
		if (isEmpty(first)) return null;

		const initials = first.slice(0, 1) + (last?.slice(0, 1) || "");
		return initials.toUpperCase();
	}, [props?.userdetail?.firstname, props?.userdetail?.lastname]);

	useEffect(() => {
		if (hasMounted.current && !isEmpty(avatar)) {
			setUpdate(true);
		} else {
			hasMounted.current = true;
		}
	}, [avatar]);

	return (
		<div className={`theme-header-profile-picture ${props.customclasses}`} style={transparentBg ? { backgroundColor: 'transparent' } : {}}>
			<div className="theme-header-initials" style={transparentBg ? { backgroundColor: 'transparent' } : {}}>
				{isEmpty(props?.userdetail?.user_img) && isEmpty(props?.lib_img) ? (
					avatar || props.children
				) : (
					<Image
						className="d-block w-100 h-100"
						src={
							!isEmpty(props.lib_img)
								? props.lib_img
								: process.env.REACT_APP_S3_BUCKET + DIR_USER_PROFILE + props?.userdetail?.user_img
						}
						style={{ objectFit: "cover" }}
					/>
				)}
			</div>
		</div>
	);
});

export default Avatar;
